import { shipmentApiClient } from '../shipmentApiClient'
import { getDeliveryReportTenantEndpoint } from './endpoint'
import type { GetDeliveryReportTenantResponse } from './type'

export const getDeliveryReportTenant = async (deliveryReportUid: string) => {
  const { data } = await shipmentApiClient.get<GetDeliveryReportTenantResponse>(
    getDeliveryReportTenantEndpoint(deliveryReportUid)
  )
  return data
}
